module.exports = __webpack_public_path__ + "static/media/folder.4e7713a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/landingpage/folder.jpg
// module id = 1643
// module chunks = 0